import React from "react"

interface KimLhcIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  height?: number;
  width?: number;
}

export function KimLhcIcon({ fill = "currentColor", height = 45, width = 47, ...props }: Readonly<KimLhcIconProps>): JSX.Element {
  return (
   <svg
      width={width}
      height={height}
      viewBox="0 0 47 45"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M42.667 6a2 2 0 00-2-2H6a2 2 0 00-2 2v14.667a2 2 0 002 2h34.667a2 2 0 002-2V6zm4 14.667a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6h34.667a6 6 0 016 6v14.667zM23.069 28.845a.533.533 0 01.795 0l6.314 7.066a.533.533 0 01-.398.889H17.154a.533.533 0 01-.398-.889l6.314-7.066z"
				fill="currentColor"
      />
      <path
        d="M25.333 36.667v7.466a.533.533 0 01-.533.534h-2.933a.533.533 0 01-.534-.534v-7.466h4zM36.283 16.455c0 1.025-.323 1.821-.97 2.39-.642.574-1.58.86-2.817.86-.333 0-.656-.026-.969-.078-.312-.052-.536-.111-.672-.177v-1.74c.223.14.483.25.782.334.298.083.564.125.797.125.496 0 .894-.12 1.192-.36.299-.24.448-.557.448-.953v-.328h-.02c-.16.243-.38.438-.662.584a1.899 1.899 0 01-.896.218c-.687 0-1.23-.238-1.63-.713-.4-.48-.6-1.14-.6-1.98 0-.576.105-1.085.313-1.526.209-.44.499-.779.87-1.015.372-.24.781-.36 1.23-.36.614 0 1.072.228 1.374.683h.021v-.552h2.209v4.588zm-2.172-2.073c0-.312-.072-.56-.214-.745a.663.663 0 00-.557-.276c-.25 0-.45.112-.6.334-.148.222-.223.519-.223.89 0 .344.062.617.187.818.125.201.323.302.594.302a.683.683 0 00.594-.307c.146-.208.219-.486.219-.833v-.183zM27.552 17.2l-1.187-2.74h-.021v2.74h-2.219V9.304h2.219v5.068h.02l1.079-2.505h2.5L28.5 14.309l1.526 2.891h-2.474zM22.77 15.065c0 .718-.26 1.276-.782 1.671-.52.396-1.265.594-2.234.594-.361 0-.719-.031-1.073-.093a4.482 4.482 0 01-.912-.24v-1.74c.233.14.499.249.797.328.299.08.601.12.907.12.354 0 .625-.062.812-.187a.62.62 0 00.287-.547c0-.24-.117-.427-.35-.563-.232-.135-.557-.203-.973-.203h-.72V12.57h.636c.42 0 .73-.064.927-.193.202-.132.303-.302.303-.51a.555.555 0 00-.23-.47c-.149-.114-.38-.17-.692-.17-.483 0-.966.138-1.448.416V9.98a4.937 4.937 0 011.906-.375c.826 0 1.474.169 1.943.505.468.337.703.804.703 1.401 0 .466-.127.856-.38 1.172-.25.316-.603.523-1.058.62v.026c.504.07.901.262 1.193.578.292.313.438.698.438 1.157zM15.333 13.111c.366.2.372.724.01.931l-3.93 2.255-.577-1.265 2.495-1.434-2.485-1.357.556-1.277 3.931 2.147z"
				fill="currentColor"
      />
    </svg>
  )
}
